import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../base/baseQuery'

export const moduleServiceApi = createApi({
  reducerPath: 'moduleServiceApi',
  baseQuery: baseQuery,
  tagTypes: ['Module'],
  endpoints: (builder) => ({
    getModules: builder.query({
      query: () => '/modules',
      providesTags: (result) =>
        result
          ? [...result.map(({ id }) => ({ type: 'Module', id })), { type: 'Module', id: 'LIST' }]
          : [{ type: 'Module', id: 'LIST' }],
    }),
    // Fetch all modules for a class
    getModulesByClassId: builder.query({
      query: (classId) => `/backoffice/class/${classId}/modules`,
      providesTags: (result, error, classId) => (result ? [{ type: 'Module', id: classId }] : []),
    }),
    // Add a new module
    addModule: builder.mutation({
      query: (newModule) => ({
        url: '/backoffice/modules/save',
        method: 'POST',
        body: newModule,
      }),
      // Use the `classId` from the argument to invalidate the tag
      invalidatesTags: (result, error, { classId }) => [{ type: 'Module', id: classId }],
    }),
    // Update a module
    updateModule: builder.mutation({
      query: ({ id, formdata }) => ({
        url: `/backoffice/modules/update/${id}`,
        method: 'Put',
        body: formdata,
      }),
      invalidatesTags: (result, error, { classId }) => [{ type: 'Module', id: classId }],
    }),
    // Delete a module
    deleteModule: builder.mutation({
      query: (id) => ({
        url: `/backoffice/modules/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { classId }) => [{ type: 'Module', id: classId }],
    }),
  }),
})

export const {
  useGetModulesQuery,
  useGetModulesByClassIdQuery,
  useAddModuleMutation,
  useUpdateModuleMutation,
  useDeleteModuleMutation,
} = moduleServiceApi
